import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
const wrapperExpandedCss = "w119v8ai";

/** Use with Wrapper when horizontal padding is provided by parent (e.g. solo attendee card). */
export const wrapperVerticalPaddingOnlyCss = "wiyukyt";

/** Stacks primary solo attendee card + guest rows with consistent vertical rhythm (flex gap avoids margin collapse). */
export const soloInviteeGuestStackCss = "s1j0dvls";

/** Direct child wrapper of inviteesCardsStackCss (enables :last-child padding override on details). */
export const inviteesStackItemCss = "i173i8yx";

/** On InviteeDetails root when listed under inviteesCardsStackCss. */
export const inviteeDetailsInCardsStackCss = "i1a20ih9";

/** Space below accordion header row (replaces margin-bottom on header when using stack gap). */
export const expandableInviteeDetailsTopGapCss = "e8bynzm";

/** Group invitee cards only; keep Show more / fewer outside so :last-child is the last card. */
export const inviteesCardsStackCss = "i71xd2q";
export const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    isGroup,
    isExpanded,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(isExpanded && wrapperExpandedCss, props.className)} />;
});
const containerLayoutCss = "crgg8jp";
const containerCss = "cheemrd";
export const containerSoloAttendeeHeaderCss = "chckh0";
const containerGroupCss = "c1353dos";
const containerOpenCss = "c17dqe3n";
const containerGroupClickableCss = "c1y42bwh";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    isOpen,
    isGroup,
    noBottomMargin = false,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(noBottomMargin ? containerLayoutCss : containerCss, {
    [containerGroupCss]: isGroup,
    [containerOpenCss]: isOpen,
    [containerGroupClickableCss]: isGroup
  }, props.className)} />;
});
const avatarContainerCss = "a1plgewr";

/** Use with AvatarContainer for fixed-size centered avatar (e.g. solo attendee card, guest row). */
export const avatarContainerFixedSizeCss = "a8sf3ek";
export const AvatarContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(avatarContainerCss, props.className)} />;
});
const avatarDropdownContainerCss = "aqvu8lm";
export const AvatarDropdownContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(avatarDropdownContainerCss, props.className)} />;
});
const avatarIconCss = "aclfvl9";
export const AvatarIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  const alt = '';
  return <Component ref={ref} {...restProps} alt={alt} className={classNames(avatarIconCss, props.className)} />;
});
const headingIsGuestCss = "h1daxirx";
const headingIsContactCss = "h1lz90p3";
const headingCss = "h1q8g53o";
export const Heading = forwardRef((props, ref) => {
  const {
    isGuest,
    isContact,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headingCss, {
    [headingIsGuestCss]: isGuest,
    [headingIsContactCss]: isContact
  }, props.className)} />;
});
const nameStrikeCss = "ne5qqv8";
const nameCss = "n1tw2yoz";
export const Name = forwardRef((props, ref) => {
  const {
    strike,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(nameCss, {
    [nameStrikeCss]: strike
  }, props.className)} />;
});
const nameStringStrikeCss = "n7znigd";
const nameStringCss = "nn01pd5";

/** Use for legacy/external invitee display so name stays bold (700); default is semibold (600) for new code. */
const nameStringBoldCss = "nk3i3qq";
export const NameString = forwardRef((props, ref) => {
  const {
    strike,
    bold,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(nameStringCss, {
    [nameStringStrikeCss]: strike,
    [nameStringBoldCss]: bold
  }, props.className)} />;
});
const rowCss = "r1podfh9";
export const Row = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rowCss, props.className)} />;
});
const infoContainerCss = "i1awfz21";
export const InfoContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(infoContainerCss, props.className)} />;
});
const guestInfoContainerCss = "g3ifmu0";
export const NameContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(guestInfoContainerCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");